import PaymentCreate from "./PaymentCreate";

export default PaymentCreate;
